import { useParams } from '@tanstack/router';
import { useCallback, useEffect, useState } from 'react';
import { staticStepRoute } from '../router/router';
import { useCaseUpdater } from './hooks/useCaseUpdater';
import { useFields } from './hooks/useFields';

import { FaAnswers } from '@/state/state.types';
import { updateCase } from '@/state/updateCase';
import { navigateToNextStepOrUrl } from '@/utils/navigateToNextStepOrUrl';
import { hasValidPartnership, normalizePartnership, partnerLogoMap } from '@/utils/partnership';
import FinancialAidStep from './FinancialAidStep';

export const FinancialAid = () => {
  const { stepId } = useParams({ from: staticStepRoute.id });
  const { isLoading } = useCaseUpdater({});
  const fields = useFields();

  const firstName = (fields?.['first-name'] as string) ?? '';
  const lastName = (fields?.['last-name'] as string) ?? '';
  const partnership = normalizePartnership(fields?.['partner']);
  const isPartnershipPreset = hasValidPartnership(partnership);
  const logoSrc = partnerLogoMap.get(partnership);

  const [answer, setAnswer] = useState<FaAnswers | ''>('');

  const handleSumit = useCallback(
    async (faAnswer: FaAnswers) => {
      const form = new FormData();
      form.append('stepId', stepId);
      form.append('answer', faAnswer);
      const caseState = await updateCase(form);

      if (faAnswer !== FaAnswers.yes) {
        navigateToNextStepOrUrl(caseState);
      }
    },
    [stepId],
  );

  useEffect(() => {
    if (answer) {
      handleSumit(answer);
    }
  }, [answer, handleSumit]);

  if (!stepId)
    throw new Error('StepId or stepName should be defined and should be a product or prep step.');

  return (
    <FinancialAidStep
      firstName={firstName}
      lastName={lastName}
      isLoading={isLoading}
      isPartnershipPreset={isPartnershipPreset}
      setAnswer={setAnswer}
      partnership={partnership}
      logoSrc={logoSrc}
    />
  );
};
